
const   getTimeStamp = (time) => {
  if (time) {
    // ios 的时间格式需要更改一下
    // eslint-disable-next-line no-param-reassign
    time = time.replace(/-/g, '/');
    return parseInt(new Date(time).getTime() / 1000, 10);
  }
  return parseInt(new Date().getTime() / 1000, 10);
};

const   copyText = (text) => {
  const textarea = document.createElement('textarea');
  document.body.appendChild(textarea);
  textarea.style.position = 'fixed';
  textarea.style.clip = 'rect(0 0 0 0)';
  textarea.style.top = '10px';
  textarea.value = text;
  textarea.select();
  document.execCommand('copy', true);
  document.body.removeChild(textarea);
  return true;
};


export  {
  getTimeStamp,
  copyText,
};

export  default  {
  getTimeStamp,
  copyText,
};
